export default "__VITE_ASSET__hGEEB8Zg__"